import { To, useNavigate } from "react-router";

type IRouterOptions = {
  /** 中断react数据更新，强制跳转 */
  flushSync?: boolean;
  /** 保持滚动条位置不变 */
  preventScrollReset?: boolean;
  /** 替换掉当前记录 */
  replace?: boolean;
  /** 额外传参，可通过 useLocation 获取 */
  state?: Record<string, any>;
  /** 是否平滑过度切换 */
  viewTransition?: boolean;
};

const useRouter = () => {
  const navigate = useNavigate();

  /** 跳转 */
  const push = (path: string, options?: IRouterOptions) => {
    navigate(path, options);
  };

  /** 覆盖跳转 */
  const replace = (path: string, options?: IRouterOptions) => {
    navigate(path, { replace: true, ...options });
  };

  /** 返回 */
  const back = (options?: IRouterOptions) => {
    navigate(-1 as To, options);
  };

  /** 打开新页面 */
  const open = (path: string) => {
    window.open(path, "_blank");
  };

  return {
    router: {
      /** 跳转 */
      push,
      /** 覆盖跳转 */
      replace,
      /** 返回 */
      back,
      /** 打开新页面 */
      open,
    },
  };
};

export default useRouter;
